import { faFileInvoice } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@shared/components/ui/button';
import { useTranslation } from 'react-i18next';

interface RatesEmptyStateProps {
  hasFilters: boolean;
  onClearFilters?: () => void;
  onCreateRate?: () => void;
  canCreate: boolean;
}

export const RatesEmptyState = ({
  hasFilters,
  onClearFilters,
  onCreateRate,
  canCreate,
}: RatesEmptyStateProps) => {
  const { t } = useTranslation('ratesModule');

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mb-4">
        <FontAwesomeIcon
          icon={faFileInvoice}
          className="text-2xl text-muted-foreground"
        />
      </div>

      <h3 className="text-lg font-medium text-title mb-2">
        {hasFilters ? t('empty.noResults') : t('empty.noRates')}
      </h3>

      <p className="text-sm text-subtext text-center max-w-md mb-6">
        {hasFilters
          ? t('empty.noResultsDescription')
          : t('empty.noRatesDescription')}
      </p>

      <div className="flex gap-3">
        {hasFilters && onClearFilters && (
          <Button variant="outline" onClick={onClearFilters}>
            {t('filters.clear')}
          </Button>
        )}

        {!hasFilters && canCreate && onCreateRate && (
          <Button
            variant="primary"
            className="!text-white"
            onClick={onCreateRate}
          >
            {t('actions.createRate')}
          </Button>
        )}
      </div>
    </div>
  );
};
